module.exports = __webpack_public_path__ + "img/icon-block.27166e23.svg";